<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="姓名" style="width: 250px" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="序号" min-width="100" prop="xuhao"></el-table-column>
          <el-table-column align="center" label="姓名" min-width="100" prop="xingming"></el-table-column>
          <el-table-column align="center" label="一级部门" min-width="100" prop="yijibumen"></el-table-column>
          <el-table-column align="center" label="二级部门" min-width="100" prop="erjibumen"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          <el-table-column align="center" label="职级" min-width="100" prop="zhiji"></el-table-column>
          <el-table-column align="center" label="学历" min-width="100" prop="xueli"></el-table-column>
          <el-table-column align="center" label="毕业院校" min-width="100" prop="biyeyuanxiao"></el-table-column>
          <el-table-column align="center" label="性别" min-width="100" prop="xingbie"></el-table-column>
          <el-table-column align="center" label="民族" min-width="100" prop="minzu"></el-table-column>
          <el-table-column align="center" label="出生日期" min-width="100" prop="chushengriqi"></el-table-column>
          <el-table-column align="center" label="年龄" min-width="100" prop="nianling"></el-table-column>
          <el-table-column align="center" label="通信地址" min-width="100" prop="tongxindizhi"></el-table-column>
          <el-table-column align="center" label="身份证号" min-width="100" prop="shenfenzheng"></el-table-column>
          <el-table-column align="center" label="身份证有效期" min-width="100" prop="youxiaoqi"></el-table-column>
          <el-table-column align="center" label="入职日期" min-width="100" prop="ruzhiriqi"></el-table-column>
          <el-table-column align="center" label="离职日期" min-width="100" prop="lizhiriqi"></el-table-column>
          <el-table-column align="center" label="劳动合同签订日期" min-width="100" prop="qiandingriqi"></el-table-column>
          <el-table-column align="center" label="劳动合同终止日期" min-width="100" prop="zhongzhiriqi"></el-table-column>
          <el-table-column align="center" label="用工形式" min-width="100" prop="yonggongxingshi"></el-table-column>
          <el-table-column align="center" label="联系电话" min-width="100" prop="lianxidianhua"></el-table-column>
          <el-table-column align="center" label="紧急联系人" min-width="100" prop="jinjilianxiren"></el-table-column>
          <el-table-column align="center" label="紧急联系人电话" min-width="100" prop="jinjidianhua"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="序号" prop="xuhao">
          <el-input v-model="editForm.xuhao"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="xingming">
          <el-input v-model="editForm.xingming"></el-input>
        </el-form-item>
        <el-form-item label="一级部门" prop="yijibumen">
          <el-input v-model="editForm.yijibumen"></el-input>
        </el-form-item>
        <el-form-item label="二级部门" prop="erjibumen">
          <el-input v-model="editForm.erjibumen"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="zhiwei">
          <el-input v-model="editForm.zhiwei"></el-input>
        </el-form-item>
        <el-form-item label="职级" prop="zhiji">
          <el-input v-model="editForm.zhiji"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="xueli">
          <el-input v-model="editForm.xueli"></el-input>
        </el-form-item>
        <el-form-item label="毕业院校" prop="biyeyuanxiao">
          <el-input v-model="editForm.biyeyuanxiao"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="xingbie">
          <el-input v-model="editForm.xingbie"></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="minzu">
          <el-input v-model="editForm.minzu"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="chushengriqi">
          <el-input v-model="editForm.chushengriqi"></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="nianling">
          <el-input v-model="editForm.nianling"></el-input>
        </el-form-item>
        <el-form-item label="通信地址" prop="tongxindizhi">
          <el-input v-model="editForm.tongxindizhi"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="shenfenzheng">
          <el-input v-model="editForm.shenfenzheng"></el-input>
        </el-form-item>
        <el-form-item label="身份证有效期" prop="youxiaoqi">
          <el-input v-model="editForm.youxiaoqi"></el-input>
        </el-form-item>
        <el-form-item label="入职日期" prop="ruzhiriqi">
          <el-input v-model="editForm.ruzhiriqi"></el-input>
        </el-form-item>
        <el-form-item label="离职日期" prop="lizhiriqi">
          <el-input v-model="editForm.lizhiriqi"></el-input>
        </el-form-item>
        <el-form-item label="劳动合同签订日期" prop="qiandingriqi">
          <el-input v-model="editForm.qiandingriqi"></el-input>
        </el-form-item>
        <el-form-item label="劳动合同终止日期" prop="zhongzhiriqi">
          <el-input v-model="editForm.zhongzhiriqi"></el-input>
        </el-form-item>
        <el-form-item label="用工形式" prop="yonggongxingshi">
          <el-input v-model="editForm.yonggongxingshi"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="lianxidianhua">
          <el-input v-model="editForm.lianxidianhua"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人" prop="jinjilianxiren">
          <el-input v-model="editForm.jinjilianxiren"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人电话" prop="jinjidianhua">
          <el-input v-model="editForm.jinjidianhua"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    xuhao: "",
    xingming: "",
    yijibumen: "",
    erjibumen: "",
    zhiwei: "",
    zhiji: "",
    xueli: "",
    biyeyuanxiao: "",
    xingbie: "",
    minzu: "",
    chushengriqi: "",
    nianling: "",
    tongxindizhi: "",
    shenfenzheng: "",
    youxiaoqi: "",
    ruzhiriqi: "",
    lizhiriqi: "",
    qiandingriqi: "",
    zhongzhiriqi: "",
    yonggongxingshi: "",
    lianxidianhua: "",
    jinjilianxiren: "",
    jinjidianhua: ""
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.search()
    },
    
    add() {
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/Qita/huamingceInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/Qita/huamingceDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = this.editForm
          data.account = localStorage.account
          this.$request.post('/index.php/admin/Qita/huamingceSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      this.$request.post('/index.php/admin/Qita/huamingceList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
